<template>
    <div v-if="isLoaderVisible" class="app-data-loader">
        <img
            src="img/loaders/Rolling-1.2s-200px.svg"
            alt="Loading data... Please wait."
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AppDataLoader',
    computed: {
        ...mapState('notifier', ['isRequestPending', 'isDataLoading']),
        isLoaderVisible() {
            return this.isRequestPending || this.isDataLoading;
        }
    }
};
</script>

<style lang="scss" scoped>
.app-data-loader {
    position: absolute;
    background-color: #00487b17;
    z-index: 9999;
    top: 5px;
    bottom: 5px;
    left: 5px;
    right: 5px;
    border-radius: 5px;

    img {
        position: absolute;
        left: calc(50% - 100px);
        top: calc(50% - 100px);
    }
}
</style>
